import enTranslationManageUsers from "./en/translation-manage-users.json";
import enTranslationEmailTemplates from "./en/translation-email-templates.json";
import enTranslationSurveyRespondentErrors from "./en/translation-survey-respondent-errors.json";
import enTranslationProjects from "./en/translation-projects.json";
import enTranslationCommon from "./en/translation-common.json";
import enTranslationFilters from "./en/translation-filters.json";
import enTranslationWelcomePage from "./en/translation-welcome-page.json";
import enTranslationSurveys from "./en/translation-surveys.json";
import enTranslationSurveyLinkStatus from "./en/translation-survey-link-status.json";
import enTranslationSurveyStatus from "./en/translation-survey-status.json";
import enTranslationErrors from "./en/translation-errors.json";
import enTranslationEmailCycles from "./en/translation-email-cycles.json";
import enTranslationSurveyDashboard from "./en/translation-survey-dashboard.json";
import enTranslationExternalPublicApis from "./en/translation-external-public-apis.json";

export const eagleEnTranslation = {
  manageUsers: enTranslationManageUsers,
  emailTemplates: enTranslationEmailTemplates,
  surveyRespondentErrors: enTranslationSurveyRespondentErrors,
  projects: enTranslationProjects,
  common: enTranslationCommon,
  filters: enTranslationFilters,
  welcomePage: enTranslationWelcomePage,
  surveys: enTranslationSurveys,
  surveyLinkStatus: enTranslationSurveyLinkStatus,
  surveyStatus: enTranslationSurveyStatus,
  errors: enTranslationErrors,
  emailCycles: enTranslationEmailCycles,
  surveyDashboard: enTranslationSurveyDashboard,
  externalPublicApis: enTranslationExternalPublicApis,
};
